// extracted by mini-css-extract-plugin
export default {"TypesMenu":"secret_TypesMenu__20Yzc","InputWrapper":"secret_InputWrapper__VgDF8","ChooseType":"secret_ChooseType__hEzAj"};